import React from "react";
import { CurrencySymbol } from "../../utils/Constants";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  AddToCartBtnHandler,
  RemoveQtyFromCartBtnHandler,
  setSelectedProductEventHandler,
} from "../../utils/globalFunctions/cartFunctions";
import { defaultImage } from "../../utils/productUtils/ProductUtils";

const RemoveVariationsProductComponent = ({ cartItemObj }) => {
  const dispatch = useDispatch();
  const decimalPoints = useSelector((state) => state.decimalPoints);

  return (
    <li>
      <div className="d-flex justify-content-start align-items-center pt-1">
        <div className="fullcartHeader d-flex justify-content-between align-items-center w-100">
          <Link
            to={`/productView/${cartItemObj.productid}`}
            className="cartProductImage"
            onContextMenu={() => {
              setSelectedProductEventHandler(cartItemObj.productid, dispatch);
            }}
            onClick={() => {
              setSelectedProductEventHandler(cartItemObj.productid, dispatch);
            }}
          >
            <span className="cartProductImageSpan">
              <img
                src={cartItemObj.imgSrc || defaultImage}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = defaultImage;
                }}
                alt=""
              />
            </span>
          </Link>
          <div className="fullcartHeading w-100 ps-3">
            <div className="fullcartName pe-2">
              <Link
                to={`/productView/${cartItemObj.productid}`}
                className="item"
                onContextMenu={() =>
                  setSelectedProductEventHandler(
                    cartItemObj.productid,
                    dispatch
                  )
                }
                onClick={() => {
                  setSelectedProductEventHandler(
                    cartItemObj.productid,
                    dispatch
                  );
                }}
              >
                <h6
                  className="d-flex justify-content-start text-start mb-0  pe-3"
                  style={{ fontWeight: "600" }}
                  dangerouslySetInnerHTML={{
                    __html: cartItemObj.productName,
                  }}
                ></h6>
              </Link>
              <span
                className="filter-item dropdown filter-dropdown selectable active me-2"
                style={{
                  display:
                    cartItemObj.variantName.length > 0 ? "initial" : "none",
                }}
              >
                {cartItemObj.variantName}
              </span>
              <div className="quantity d-flex justify-content-between py-2 align-items-center">
                <div className="cd-price fw-bold cd-item-remove text-end m-0">
                  {CurrencySymbol}
                  {parseFloat(cartItemObj.price * cartItemObj.quantity).toFixed(
                    decimalPoints
                  )}
                </div>
                <div className="productAddCartCounter customVariant  productCounter d-flex flex-row col-sm-6">
                  <i
                    className="fas fa-minus minus minusButtonCart buttons  d-flex justify-content-center align-items-center"
                    onClick={() => {
                      RemoveQtyFromCartBtnHandler(
                        cartItemObj.productVarientId,
                        dispatch
                      );
                    }}
                  ></i>
                  <span className="cart-counter text-center col-3 fw-bolder">
                    {cartItemObj.quantity}
                  </span>
                  <i
                    className="fas fa-plus plus plusButtonCart buttons  d-flex justify-content-center align-items-center"
                    onClick={() => {
                      AddToCartBtnHandler(
                        cartItemObj.productVarientId,
                        cartItemObj.price,
                        cartItemObj.imgSrc,
                        cartItemObj.productName,
                        cartItemObj.productid,
                        cartItemObj.availableQuantity,
                        cartItemObj.variantName,
                        { activeOnline : 1},
                        dispatch
                      );
                    }}
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </li>
  );
};

export default RemoveVariationsProductComponent;
